import { useReduxState } from 'hooks';
import { getAISupportedBlocks } from 'shared-helpers/aiTools';
import { Tooltip } from 'components/common';
import { Icon } from 'components/common/icons';
import { useEditorContext } from 'components/editor';

import type { EditorBlockTypes } from 'types';

interface Props {
  type?: EditorBlockTypes;
}

const AIGenerateContentBlockIndicator = ({ type }: Props) => {
  const { editorAIEnabled } = useEditorContext();

  const {
    messages,
    serverConfig: { aiConfig }
  } = useReduxState();

  const availableBlockTypes = getAISupportedBlocks(aiConfig.allowedBlockTypes);
  if (
    !editorAIEnabled ||
    (type && !availableBlockTypes.includes(type as any))
  ) {
    return null;
  }

  return (
    <Tooltip childrenWrapInDiv={false} content={messages.aiToolsAvailable}>
      <div className="block-indicator">
        <Icon icon="wand-magic-sparkles" />

        <style jsx>{`
          .block-indicator {
            align-items: center;
            background-color: white;
            border-radius: 50px;
            display: inline-flex;
            font-size: 1.2rem;
            justify-content: center;
            overflow: hidden;
            height: 20px;
            width: 20px;
            position: absolute;
            top: 5px;
            right: 5px;
          }
        `}</style>
      </div>
    </Tooltip>
  );
};

export default AIGenerateContentBlockIndicator;
